import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { LINKS } from "../../constants";

export const AuthenticatedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) return <Navigate to={LINKS.login} />;

  return children;
};

AuthenticatedRoute.propTypes = {
  children: PropTypes.object.isRequired,
};
